import { Suspense, lazy } from 'react';

const ChangePassword = lazy(() => import('../common/PasswordChange'));

const ChangePasswordLazy: React.FC = () => {
    return <Suspense><ChangePassword/></Suspense>;
}

export default ChangePasswordLazy;